

export default () => ({
    status: 'authenticating', //'authenticated', 'not-authenticated', 'authenticating'
    user: null,
    idToken: null,
    refreshToken: null
})